<template>
  <div class="main-form">
    <!-- 加载指示器 -->
    <div v-if="isLoading" class="loading-bar">
      <div class="loading-bar-progress"></div>
    </div>

    <div class="header">
      <h1>
        二维码
        <h3>{{ pageTitle }}</h3>
      </h1>

      <!-- 列表视图工具栏 -->
      <div class="toolbar" v-if="isListView">
        <button class="add-btn" @click="toggleView">
          <span><i class="fas fa-plus"></i> 新增</span>
        </button>
      </div>

      <!-- 非列表视图（创建/详情）工具栏 -->
      <div class="toolbar1" v-else>
        <button class="add-btn" @click="toggleView">
          <span><i class="fas fa-list"></i> 列表</span>
        </button>
      </div>
    </div>

    <div class="table-container" v-if="isListView">
      <table class="data-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                @change="toggleSelectAll"
                :checked="isAllSelected"
              />
            </th>
            <th>ID</th>
            <th>唯一码</th>
            <th v-if="!isMobile">年化(%)</th>
            <th v-if="!isMobile">额度(元)</th>
            <th v-if="!isMobile">二维码</th>
            <th v-if="!isMobile">更新时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in paginatedData" :key="row.id">
            <td>
              <input type="checkbox" :value="row.id" v-model="selectedRows" />
            </td>
            <td>{{ row.id }}</td>
            <td>{{ row.uniqueCode }}</td>
            <td v-if="!isMobile">{{ row.annualRate }}%</td>
            <td v-if="!isMobile">{{ row.creditLimit }}</td>
            <td v-if="!isMobile">
              <img
                :src="row.qrCodeUrl"
                alt="二维码"
                @click="enlargeImage(row.qrCodeUrl)"
                class="qr-code-img"
              />
            </td>
            <td v-if="!isMobile">{{ row.updatedAt }}</td>
            <td>
              <button v-if="isMobile" class="mobile-view-btn" @click="showDetail(row)">
                <i class="fas fa-eye"></i>
              </button>
              <div v-if="!isMobile">
                <button @click="editRow(row.id)">
                  <i class="fas fa-edit"></i>
                </button>
                <button @click="deleteRow(row.id)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 分页 -->
    <div class="pagination" v-if="isListView">
      <div>
        <label class="showPage" for="pageSize">每页显示:</label>
        <select v-model="pageSize" id="pageSize">
          <option value="10">10条</option>
          <option value="20">20条</option>
          <option value="30">30条</option>
          <option value="50">50条</option>
        </select>
      </div>
      <div>
        <button v-if="!isMobile" @click="prevPage" :disabled="currentPage === 1">
          上一页
        </button>
        <button v-if="isMobile" @click="prevPage" :disabled="currentPage === 1">
          ◀
        </button>
        <div class="jump">
          跳转到&nbsp;
          <input
            type="number"
            v-model.number="gotoPage"
            min="1"
            :max="totalPages"
            @change="jumpToPage"
          />&nbsp;页
        </div>
        <button
          v-if="!isMobile"
          @click="nextPage"
          :disabled="currentPage >= totalPages"
        >
          下一页
        </button>
        <button
          v-if="isMobile"
          @click="nextPage"
          :disabled="currentPage >= totalPages"
        >
          ▶
        </button>
      </div>
      <div>
        <span class="page-info"
          >第 {{ currentPage }} 页，共 {{ totalPages }} 页</span
        >
      </div>
    </div>

    <!-- 创建 / 详情视图 -->
    <div class="detail" v-else>
      <form v-if="isCreating" @submit.prevent="submitForm">
        <br />
        <hr class="myhr" />
        <br />
        <div class="row">
          <div class="control-label">
            <div style="color: red">*&nbsp;&nbsp;</div>
            年化 (%)
          </div>
          <div class="box-body">
            <input type="text" v-model="formData.annualRate" required />
            <span>&nbsp;%</span>
          </div>
        </div>
        <div class="row">
          <div class="control-label">
            <div style="color: red">*&nbsp;&nbsp;</div>
            额度(元)
          </div>
          <div class="box-body">
            <input type="number" v-model="formData.creditLimit" required />
            <span>&nbsp;元</span>
          </div>
        </div>
        <br />
        <hr class="myhr" />
        <button type="submit"><i class="fas fa-save"></i> 提交</button>
      </form>

      <div v-else>
        <form @submit.prevent="updateDetails">
          <br />
          <hr class="myhr" />
          <br />
          <div class="row">
            <div class="control-label">ID:</div>
            <div class="box-body">{{ details.id }}</div>
          </div>
          <div class="row">
            <div class="control-label">唯一码:</div>
            <div class="box-body">{{ details.uniqueCode }}</div>
          </div>
          <div class="row">
            <div class="control-label">
              <div v-if="isEditing" style="color: red">*&nbsp;&nbsp;</div>
              年化 (%):
            </div>
            <div class="box-body">
              <div v-if="!isEditing">{{ details.annualRate }}%</div>
              <div v-else>
                <input type="text" v-model="formData.annualRate" required />
                <span>&nbsp;%</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="control-label">
              <div v-if="isEditing" style="color: red">*&nbsp;&nbsp;</div>
              额度 (元):
            </div>
            <div class="box-body">
              <div v-if="!isEditing">{{ details.creditLimit }}元</div>
              <div v-else>
                <input type="number" v-model="formData.creditLimit" required />
                <span>&nbsp;元</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="isEditing">
            <div class="control-label">二维码:</div>
            <div class="box-body">
              <img
                :src="details.qrCodeUrl"
                alt="QR Code"
                @click="enlargeImage(details.qrCodeUrl)"
              />
            </div>
          </div>
          <div class="row">
            <div class="control-label">创建时间:</div>
            <div class="box-body">{{ details.createdAt }}</div>
          </div>
          <div class="row">
            <div class="control-label">更新时间:</div>
            <div class="box-body">{{ details.updatedAt }}</div>
          </div>
          <br />
          <hr class="myhr" />
          <br />
          <button @click="editDetails" v-if="!isEditing">
            <i class="fas fa-pencil-alt"></i> 编辑
          </button>
          <button @click="deleteDetails" v-if="!isEditing">
            <i class="fas fa-trash"></i> 删除
          </button>
          <button type="submit" v-if="isEditing">
            <i class="fas fa-check"></i> 更新
          </button>
          <button @click="resetForm" v-if="isEditing">
            <i class="fas fa-redo"></i> 重置
          </button>
        </form>
      </div>
    </div>

    <!-- 手机端详情弹窗 -->
    <div v-if="isDetailOpen" class="detail-modal">
      <div class="detail-content">
        <button class="close-detail" @click="isDetailOpen = false">X</button>
        <table class="detail-table">
          <tr v-for="(value, key) in selectedRow" :key="key">
            <td>{{ keyTranslations[key] || key }}</td>
            <td>{{ value }}</td>
          </tr>
        </table>
        <div class="actions">
          <button @click="editRow(selectedRow.id)" class="mobile-view-btn">
            <i class="fas fa-edit"></i>
          </button>
          <button @click="deleteRow(selectedRow.id)" class="mobile-view-btn">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- 图片放大模态框 -->
    <div v-if="isModalOpen" class="modal" @click="isModalOpen = false">
      <img :src="modalImage" alt="放大图片" />
    </div>

    <!-- 返回顶部 -->
    <div v-if="showBackToTop" class="back-to-top" @click="scrollToTop">↑</div>

    <CustomAlert v-if="showAlert" :message="alertMessage" :type="alertType" class="confirm" />
    <CustomConfirm
      :isVisible="isConfirmVisible"
      title="确认删除"
      message="您确定要删除这条记录吗？此操作无法撤销。"
      @confirm="confirmDelete"
      @cancel="() => isConfirmVisible = false"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import axios from "@/axios";
import CustomAlert from "@/components/CustomAlert.vue";
import CustomConfirm from "@/components/CustomConfirm.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const router = useRouter();

const tableData = ref([]);
const selectedRows = ref([]);
const isAllSelected = computed(() => selectedRows.value.length === tableData.value.length);

const pageSize = ref(10);
const currentPage = ref(1);
const sortKey = ref("");
const sortDirection = ref("asc");
const isModalOpen = ref(false);
const modalImage = ref("");
const isDetailOpen = ref(false);
const isMobile = ref(window.innerWidth <= 768);
const showBackToTop = ref(false);
const selectedRow = ref({});
const gotoPage = ref(1);
const pageTitle = ref("列表");
const isListView = ref(true);
const isCreating = ref(false);
const isEditing = ref(false);
const showAlert = ref(false);
const alertMessage = ref("");
const alertType = ref("");
const isConfirmVisible = ref(false);
const selectedRowId = ref(null);

const formData = ref({
  annualRate: 0.0,
  creditLimit: 0,
});

const details = ref({
  id: "",
  uniqueCode: "",
  annualRate: 0.0,
  creditLimit: 0,
  createdAt: "",
  updatedAt: "",
  qrCodeUrl: "",
});

const keyTranslations = {
  id: "编号",
  uniqueCode: "唯一码",
  annualRate: "年化(%)",
  creditLimit: "额度(元)",
  qrCode: "二维码",
  updatedAt: "更新时间",
};

const isLoading = ref(false);

const fetchTableData = async () => {
  isLoading.value = true;
  try {
    const response = await axios.get("/qr");
    if (response.status === 200) {
      tableData.value = response.data || [];
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response?.data?.error || "获取数据失败", "error");
    console.error("获取数据失败:", error);
    if (error.response?.data?.error === "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  } finally {
    isLoading.value = false;
  }
};

const showCustomAlert = (message, type = "info") => {
  alertMessage.value = message;
  alertType.value = type;
  showAlert.value = true;
  setTimeout(() => { showAlert.value = false; }, 3000);
};

const toggleView = () => {
  isListView.value = !isListView.value;
  if (isListView.value) {
    pageTitle.value = "列表";
    isCreating.value = false;
    isEditing.value = false;
    fetchTableData();
  } else {
    pageTitle.value = "创建";
    isCreating.value = true;
    resetForm();
  }
};

const submitForm = async () => {
  pageTitle.value = "详细";
  isCreating.value = false;
  const req = {
    annual_rate: parseFloat(formData.value.annualRate),
    credit_limit: parseFloat(formData.value.creditLimit),
  };
  try {
    const response = await axios.post("/qr", req);
    if (response.status === 200) {
      showCustomAlert(response.data.message, "success");
      const data = {
        id: response.data.id,
        uniqueCode: response.data.unique_code,
        createdAt: response.data.created_at,
        updatedAt: response.data.updated_at,
        annualRate: response.data.annual_rate,
        qrCodeUrl: response.data.qr_code_path,
        creditLimit: response.data.credit_limit,
      };
      tableData.value.push(data);
      details.value = data;
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response?.data?.error || "提交失败", "error");
    if (error.response?.data?.error === "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }
};

const editDetails = () => {
  isEditing.value = true;
  formData.value = { ...details.value };
};

const updateDetails = async () => {
  isEditing.value = false;
  const req = {
    annual_rate: parseFloat(formData.value.annualRate),
    credit_limit: parseFloat(formData.value.creditLimit),
  };
  try {
    const response = await axios.put(`/qr/${details.value.id}`, req);
    if (response.status === 200) {
      showCustomAlert(response.data.message, "success");
      details.value = { ...formData.value, updatedAt: new Date().toLocaleString() };
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response?.data?.error || "更新失败", "error");
    if (error.response?.data?.error === "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }
};

const deleteDetails = () => {
  selectedRowId.value = details.value.id;
  isConfirmVisible.value = true;
};

const confirmDelete = async () => {
  try {
    const response = await axios.delete(`/qr/${selectedRowId.value}`);
    if (response.status === 200) {
      showCustomAlert(response.data.message, "success");
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response?.data?.error || "删除失败", "error");
    if (error.response?.data?.error === "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  } finally {
    isConfirmVisible.value = false;
    selectedRowId.value = null;
    fetchTableData();
    isListView.value = true;
    pageTitle.value = "列表";
    isCreating.value = false;
    isEditing.value = false;
    isDetailOpen.value = false;
  }
};

const editRow = (id) => {
  isDetailOpen.value = false;
  const row = tableData.value.find((r) => r.id === id);
  if (row) {
    isListView.value = false;
    pageTitle.value = "详细";
    isCreating.value = false;
    isEditing.value = true;
    details.value = { ...row };
    formData.value.annualRate = row.annualRate;
    formData.value.creditLimit = row.creditLimit;
  }
};

const deleteRow = (id) => {
  selectedRowId.value = id;
  isConfirmVisible.value = true;
  isDetailOpen.value = false;
};

const resetForm = () => {
  formData.value.annualRate = "";
  formData.value.creditLimit = "";
};

const paginatedData = computed(() => {
  let sortedData = [...tableData.value];
  if (sortKey.value) {
    sortedData.sort((a, b) => {
      const order = sortDirection.value === "asc" ? 1 : -1;
      return (a[sortKey.value] < b[sortKey.value] ? -1 : 1) * order;
    });
  }
  const start = (currentPage.value - 1) * pageSize.value;
  return sortedData.slice(start, start + pageSize.value);
});

const totalPages = computed(() => Math.ceil(tableData.value.length / pageSize.value));

const nextPage = () => { if (currentPage.value < totalPages.value) currentPage.value++; };
const prevPage = () => { if (currentPage.value > 1) currentPage.value--; };

const jumpToPage = () => {
  if (gotoPage.value >= 1 && gotoPage.value <= totalPages.value) {
    currentPage.value = gotoPage.value;
  }
};

const enlargeImage = (src) => {
  modalImage.value = src;
  isModalOpen.value = true;
};

const showDetail = (row) => {
  selectedRow.value = row;
  isDetailOpen.value = true;
};

const toggleSelectAll = () => {
  if (isAllSelected.value) {
    selectedRows.value = [];
  } else {
    selectedRows.value = tableData.value.map(row => row.id);
  }
};

// 响应式与滚动
window.addEventListener("resize", () => {
  isMobile.value = window.innerWidth <= 768;
});

const handleScroll = () => {
  showBackToTop.value = window.scrollY > 200;
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

onMounted(() => {
  fetchTableData();
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
/* ========== 全局基础 ========== */
.main-form {
  padding: 24px 32px;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background: linear-gradient(135deg, #f5f7fc 0%, #eef2f8 100%);
  min-height: 100vh;
  color: #1a2634;
}

/* ========== 头部 ========== */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 20px;
  backdrop-filter: blur(2px);
}

.header h1 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #1f2b38, #2c3e4e);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  letter-spacing: -0.01em;
}

.header h3 {
  margin: 6px 0 0 4px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #5b6e8c;
}

/* 工具栏按钮 */
.toolbar, .toolbar1 {
  display: flex;
  gap: 14px;
  align-items: center;
  flex-wrap: wrap;
}

.add-btn {
  background: linear-gradient(105deg, #2c3e50 0%, #1e2a36 100%);
  border: none;
  padding: 10px 24px;
  border-radius: 40px;
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  letter-spacing: 0.3px;
}

.add-btn:hover {
  background: linear-gradient(105deg, #1e2a36, #141f28);
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

/* ========== 表格容器 ========== */
.table-container {
  background: white;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
  margin-bottom: 28px;
  border: 1px solid rgba(226, 237, 242, 0.6);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  min-width: 1000px;
}

.data-table th {
  background: #fafcfd;
  color: #2c3e50;
  font-weight: 600;
  padding: 16px 12px;
  border-bottom: 1px solid #e9f0f3;
  font-size: 0.85rem;
  letter-spacing: 0.3px;
}

.data-table td {
  padding: 14px 12px;
  text-align: center;
  border-bottom: 1px solid #eff3f6;
  color: #2c3e50;
}

.data-table tr:hover td {
  background-color: #f8fbfd;
}

/* 二维码图片 */
.qr-code-img {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  cursor: pointer;
}

.qr-code-img:hover {
  transform: scale(1.02);
}

/* 表格内操作按钮（PC端） */
.data-table td button {
  background: transparent;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 40px;
  margin: 0 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #5a7a9a;
  font-size: 1rem;
}

.data-table td button:hover {
  background: #f0f4f9;
  color: #2c3e50;
  transform: translateY(-2px);
}

.data-table td button:active {
  transform: translateY(1px);
}

/* ========== 分页组件 ========== */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  background: white;
  padding: 14px 20px;
  border-radius: 60px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  width: fit-content;
  margin: 0 auto;
  border: 1px solid #e9f0f3;
}

.pagination > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination button {
  background: white;
  border: 1px solid #dee7ec;
  padding: 8px 18px;
  border-radius: 32px;
  font-weight: 500;
  font-size: 0.85rem;
  color: #2c3e50;
  cursor: pointer;
  transition: 0.2s;
}

.pagination button:hover:not(:disabled) {
  background: #f0f4f9;
  border-color: #b9ccd9;
  transform: translateY(-1px);
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination select, .pagination input {
  border: 1px solid #dee7ec;
  border-radius: 32px;
  padding: 8px 14px;
  background: white;
  font-size: 0.85rem;
  outline: none;
  transition: 0.2s;
}

.pagination select:focus, .pagination input:focus {
  border-color: #8ba0b0;
  box-shadow: 0 0 0 2px rgba(99, 125, 145, 0.2);
}

.showPage {
  font-size: 0.85rem;
  color: #4a627a;
  margin-right: 6px;
}

.page-info {
  font-size: 0.85rem;
  background: #f2f6f9;
  padding: 6px 14px;
  border-radius: 32px;
  color: #2c3e50;
}

/* ========== 详情表单卡片 ========== */
.detail {
  background: white;
  border-radius: 32px;
  padding: 32px 36px;
  max-width: 880px;
  margin: 20px auto;
  box-shadow: 0 20px 35px -12px rgba(0, 0, 0, 0.1);
  border: 1px solid #eef3f8;
}

.detail .row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
  flex-wrap: wrap;
}

.detail .control-label {
  width: 140px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.9rem;
  text-align: right;
  display: flex;
  align-items: center;
  gap: 4px;
}

.detail .box-body {
  flex: 1;
  padding: 12px 18px;
  border: 1px solid #dfe8ef;
  border-radius: 48px;
  background: white;
  font-size: 0.9rem;
  transition: 0.2s;
}

.detail .box-body:focus-within {
  border-color: #8ba0b0;
  box-shadow: 0 0 0 2px rgba(99, 125, 145, 0.2);
}

.detail input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.9rem;
}

/* 表单按钮区域统一布局 */
.detail form {
  display: flex;
  flex-direction: column;
}

.detail form > button,
.detail form .form-actions {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

/* 按钮统一样式 */
.detail button {
  min-width: 120px;
  padding: 12px 24px;
  border-radius: 40px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: 0.2s;
  cursor: pointer;
  border: none;
}

/* 主按钮（提交/更新） */
.detail button[type="submit"] {
  background: #2c3e50;
  color: white;
  align-items:center;
}

.detail button[type="submit"]:hover {
  background: #1e2a36;
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
}

/* 次按钮（重置/编辑/删除等） */
.detail button:not([type="submit"]) {
  background: #f0f4f9;
  border: 1px solid #dfe8ef;
  color: #4a627a;
}

.detail button:not([type="submit"]):hover {
  background: #e6edf4;
  border-color: #cbdde6;
  transform: translateY(-1px);
}

/* 横线 */
.myhr {
  margin: 24px 0;
  border: 0;
  height: 1px;
  background: linear-gradient(to right, transparent, #dfe8ef, transparent);
}

/* ========== 模态框（图片放大） ========== */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  cursor: pointer;
}

.modal img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 28px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

/* ========== 手机端详情弹窗 ========== */
.detail-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
}

.detail-content {
  background: white;
  padding: 28px;
  border-radius: 36px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  position: relative;
}

.close-detail {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #f0f4f9;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 30px;
  font-size: 1.4rem;
  cursor: pointer;
  color: #4a627a;
  display: flex;
  align-items: center;
  justify-content: center;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
}

/* 移动端详情表格 */
.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 20px;
}

.detail-table tr {
  border-bottom: 1px solid #eff3f8;
}

.detail-table tr:last-child {
  border-bottom: none;
}

.detail-table th,
.detail-table td {
  padding: 14px 16px;
  vertical-align: top;
  line-height: 1.4;
}

.detail-table th {
  width: 35%;
  font-weight: 600;
  color: #2c3e50;
  background-color: #fafcfd;
  text-align: left;
  border-right: 1px solid #eff3f8;
}

.detail-table td {
  color: #4a627a;
  background-color: #ffffff;
  word-break: break-word;
}

@media (max-width: 640px) {
  .detail-table th,
  .detail-table td {
    padding: 12px 12px;
    font-size: 0.85rem;
  }
  .detail-table th {
    width: 40%;
  }
}

/* 移动端圆形按钮 */
.mobile-view-btn {
  width: 44px;
  height: 44px;
  background: #f8fafc;
  border: 1px solid #e2edf2;
  border-radius: 50%;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #4a627a;
}

.mobile-view-btn i {
  font-size: 1.2rem;
}

.mobile-view-btn:hover {
  background: #eef3f8;
  border-color: #cbdde6;
}

.mobile-view-btn:active {
  transform: scale(0.94);
}

/* ========== 加载进度条 ========== */
.loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: #e2edf2;
  z-index: 2000;
}

.loading-bar-progress {
  height: 100%;
  background: linear-gradient(90deg, #2c3e50, #5d7f9e);
  animation: loading 1.2s infinite ease;
}

@keyframes loading {
  0% { width: 0%; left: 0; }
  50% { width: 70%; left: 15%; }
  100% { width: 100%; left: 0; }
}

/* ========== 返回顶部 ========== */
.back-to-top {
  position: fixed;
  bottom: 32px;
  right: 24px;
  width: 48px;
  height: 48px;
  background: #2c3e50;
  color: white;
  border-radius: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: 0.2s;
  z-index: 1000;
}

.back-to-top:hover {
  transform: translateY(-4px);
  background: #1e2a36;
}

/* ========== 响应式调整 ========== */
@media (max-width: 768px) {
  .main-form {
    padding: 20px 16px;
  }

  .jump {
     font-size: small;
  }

  .pagination button{
    padding: 3px 10px;
  }

  .header h1 {
    font-size: 1.5rem;
  }

  .pagination {
    flex-direction: column;
    width: 100%;
    border-radius: 40px;
    padding: 12px 18px;
  }

  .detail {
    padding: 24px 20px;
  }

  .detail .row {
    flex-direction: column;
    align-items: flex-start;
  }

  .detail .control-label {
    width: auto;
    text-align: left;
  }

  .detail .box-body {
    width: 100%;
  }

  .detail button {
    min-width: 100px;
    padding: 10px 20px;
  }
}

/* ========== 修复表单内单位换行 ========== */
.detail .box-body {
  flex: 1;
  padding: 12px 18px;
  border: 1px solid #dfe8ef;
  border-radius: 48px;
  background: white;
  font-size: 0.9rem;
  transition: 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap; /* 确保不换行 */
}

.detail .box-body input {
  flex: 1;
  min-width: 0; /* 防止溢出 */
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.9rem;
}

.detail .box-body span {
  flex-shrink: 0;  /* 单位不缩小 */
  white-space: nowrap;
  color: #5b6e8c;
}

/* 手机端输入框单位处理 */
@media (max-width: 768px) {
  .detail .box-body {
    padding: 12px 16px;
    gap: 6px;
  }

  .detail .box-body span {
    font-size: 0.85rem;
  }
}

/* ========== 移动端字体整体优化 ========== */
@media (max-width: 768px) {
  .main-form {
    font-size: 14px;
  }

  /* 表格字号 */
  .data-table th,
  .data-table td {
    font-size: 13px;
    padding: 10px 6px;
  }

  /* 按钮字号 */
  .add-btn,
  .detail button,
  .pagination button {
    font-size: 13px;
    padding: 5px 10px;
  }

  /* 移动端圆形按钮微调 */
  .mobile-view-btn {
    width: 40px;
    height: 40px;
  }

  .mobile-view-btn i {
    font-size: 1rem;
  }

  /* 表单内部 */
  .detail .control-label {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .detail .box-body {
    font-size: 14px;
  }

  .detail .box-body input {
    font-size: 14px;
  }

  /* 分页信息字体 */
  .page-info,
  .showPage {
    font-size: 13px;
  }

  /* 弹窗内容字体 */
  .detail-table th,
  .detail-table td {
    font-size: 13px;
  }

  /* 关闭按钮 */
  .close-detail {
    width: 36px;
    height: 36px;
    font-size: 1.2rem;
  }
}

/* 可选：增加手机端输入框高度，便于触摸 */
@media (max-width: 768px) {
  .detail .box-body {
    padding: 14px 18px;
  }
}

/* ========== 修复编辑模式下单位换行 ========== */
/* 让编辑模式中包裹输入框和单位的容器也使用 flex 布局 */
.detail .box-body > div {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  width: 100%;
}

.detail .box-body > div input {
  flex: 1;
  min-width: 0;
}

.detail .box-body > div span {
  flex-shrink: 0;
  white-space: nowrap;
}

/* 手机端进一步优化单位不换行 */
@media (max-width: 768px) {
  .detail .box-body > div {
    gap: 6px;
  }
  .detail .box-body > div span {
    font-size: 0.85rem;
  }
}
</style>